var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tagTitle)?_c('a',{staticClass:"text-center inline col-4",attrs:{"href":_vm.href,"target":"_blank"}},[(_vm.tagTitle)?_c('b-card',[_c('blockquote',{staticClass:"blockquote mb-0"},[_vm._v(_vm._s(_vm.tagTitle))])]):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }